import React, {FC} from 'react';
import {Flex} from '@priority-software/priority-style-react';
import styles from './styles.module.scss';
import {TVoidFunction} from '../../../../../../../../EmailEditor/types';
import {useNewEmailTemplate} from './hooks/useNewEmailTemplate';
import {createDataTestId} from '../../../../../../../../../utils/dataTestId';

export interface INewEmailTemplate {
    handleEmailDialog: TVoidFunction;
    subject: string;
}

export const NewEmailTemplate: FC<INewEmailTemplate> = ({handleEmailDialog, subject}) => {
    const {renderIcon, renderSubject, renderButtons} = useNewEmailTemplate({
        handleEmailDialog,
        subject
    });

    return (
        <Flex
            {...createDataTestId(`new-email-template-container`, true)}
            componentClasses={styles.container}
        >
            {renderIcon()}
            <Flex
                componentClasses={styles.emailContainer}
                direction="column"
                justifyContent="space-between"
                alignItems="flex-start"
            >
                {renderSubject()}
                {renderButtons()}
            </Flex>
        </Flex>
    );
};
